// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XpXR","left":"styles_left__3bBTY"};